import { Component } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Subscription } from "rxjs/Subscription";
import { LocalStorageService } from "angular-2-local-storage";
import { AlertService } from "../../../services";
import { Column } from "../../admin/column";
import { StoreStatus } from "./store-status";
import { TableState } from "../../admin/table-state";
import { StoreStatusService } from "./store-status.service";
import { BaseTableComponent } from "../../admin/base-table.component";

@Component({
    template: require('./store-status.html'),
    selector: 'store-status',
    providers: [StoreStatusService],
    styles: [require('../../admin/table.css')]
})

export class StoreStatusComponent extends BaseTableComponent {

    private storeStatuses = new Array<StoreStatus>();
    private searchTableState: TableState;
    private columns: Array<Column>;
    private busy: Subscription;

    constructor(
        private storeStatusService: StoreStatusService,
        private router: Router,
        private route: ActivatedRoute,
        private alertService: AlertService,
        private localStorageService: LocalStorageService
    ) {
        super(localStorageService, storeStatusService.searchTableState);
        this.setColumns();
    }

    ngOnInit() {
        this.searchTableState = this.storeStatusService.searchTableState;
        this.setPageSize('store-status-page-size');
        this.blankPage();
        this.updateTable();
    }

    private setColumns() {
        this.columns = new Array<Column>();
        this.columns.push(new Column('Store', 'StoreGroupCode'));
        this.columns.push(new Column('Last Loyalty Transaction', 'LastLoyaltyTransaction'));
        this.columns.push(new Column('Total Enquiries', 'TotalEnquiries'));
        this.columns.push(new Column('No. of Failures', 'FailureCount'));
        this.columns.push(new Column('No. of Fraud Triggers', 'FraudTriggerCount'));
    }

    private blankPage() {
        this.storeStatuses = new Array<StoreStatus>();
        for (let i: number = 0; i < this.searchTableState.itemsPerPage; i++) {
            this.storeStatuses.push(new StoreStatus());
        }
    }

    private updateTable(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: StoreStatusComponent = this;
        this.busy = this.storeStatusService.search().subscribe((message: Array<StoreStatus>) => {
            self.searchTableState.updating = false;
            self.storeStatuses = message;
        }, error => self.searchTableState.updating = false);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/store-status/store-status.component.ts